import { useSelector } from '../../_shared/utils/hooks/useSelector';
import { type AppState } from '../../store/app.store';

export const mapSettingsSelector = (state: AppState) => state.map.mapSettings.data;
export const useMapSettingsDataSelector = () => useSelector(mapSettingsSelector);
